class TjipWindowService {
  public changeHref(href: string): Promise<void> {
    return new Promise(resolve => {
      const handler = () => {
        window.removeEventListener('load', handler);
        resolve();
      };
      window.addEventListener('load', handler);
      window.location.href = href;
    });
  }
}

export const tjipWindowService = new TjipWindowService();
